import { Component, OnInit } from '@angular/core';
import { ManageUserService } from '../manage-user.service';
import { User, status } from '../../../core/user';
import { Investor } from '../../shared/models/investor';

@Component({
  selector: 'app-existing-user',
  templateUrl: './existing-user.component.html',
  styleUrls: ['./existing-user.component.css']
})
export class ExistingUserComponent implements OnInit {
  userList: User[];
  investorList: Investor[];
  newInvestorList: Investor[];
  newStatusCount: number[];
  constructor(private manageUserService: ManageUserService) {
    this.newStatusCount = [];
  }

  ngOnInit() {
    const x = this.manageUserService.getData();
    x.valueChanges().subscribe(item => {
      this.userList = item;
      this.userList.sort((a: User, b: User) => {
        var aWeight = a.roles.admin ? 3 : a.roles.editor ? 2 : 1;
        var bWeight = b.roles.admin ? 3 : b.roles.editor ? 2 : 1;
        if (bWeight - aWeight !== 0) {
          return a.displayName.localeCompare(b.displayName);
        }
        return 0;
      });
    });

    // const y = this.manageUserService.getInvestors();
    // y.valueChanges().subscribe(item => {
    //     this.investorList = item;
    // });

    const z = this.manageUserService.getNewStatusInvestors();
    z.valueChanges().subscribe(item => {
        this.newInvestorList = item;
        this.newStatusCount = [];
        this.countNewStatuses();
    });
  }

  countNewStatuses() {
    this.newInvestorList.forEach((element, index) => {
      this.newStatusCount[element.creatorId] = (this.newStatusCount[element.creatorId] || 0) + 1;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/manage-user/existing-user/existing-user.component.ts